import { jsx as _jsx } from "react/jsx-runtime";
// @ts-ignore-next-line importsNotUsedAsValues
import 'react';
import classNames from 'classnames';
const TreeNodeContainer = (props) => {
    const { isOpen, groupId, disableAnimation, children } = props;
    const treeNodeContainerClasses = classNames('TreeNodeContainer', 'user-select-none overflow-hidden', isOpen && 'open');
    return (_jsx("div", Object.assign({ className: treeNodeContainerClasses, "data-id": groupId }, { children: children })));
};
export default TreeNodeContainer;
